/**
 * Firebase Initialization
 * 
 * This file initializes Firebase services (Auth, Firestore & App Check).
 * Import these instances wherever you need Firebase functionality.
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import firebaseConfig from './config';

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication (for Anonymous Auth)
export const auth = getAuth(app);

// Initialize Firestore Database
export const db = getFirestore(app);

// Initialize App Check (Bot Protection)
// This protects your Firestore from abuse by validating requests come from your app
if (typeof window !== 'undefined') {
  // Only initialize in browser environment
  const appCheckKey = process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY;
  
  if (appCheckKey) {
    try {
      // Enable debug mode in development
      if (process.env.NODE_ENV === 'development') {
        // Enable debug tokens for localhost testing
        window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
        console.log('🔧 App Check DEBUG mode enabled for development');
      }
      
      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(appCheckKey),
        
        // Auto-refresh tokens
        isTokenAutoRefreshEnabled: true
      });
      console.log('App Check initialized successfully');
    } catch (error) {
      console.warn(' App Check initialization failed:', error.message);
      // App will still work, but without App Check protection
    }
  } else {
    console.warn('App Check key not found. Add REACT_APP_FIREBASE_APP_CHECK_KEY to .env');
  }
}

// Export app instance (rarely needed, but available)
export default app;
